// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const jellicent: PokeData = {
  "id": 593,
  "name": "jellicent",
  "height": 22,
  "weight": 1350,
  "base_experience": 168,
  "types": [
    PokeType.WATER,
    PokeType.GHOST
  ],
  "api_moves": [
    "poison-sting",
    "water-gun",
    "hydro-pump",
    "bubble-beam",
    "absorb",
    "night-shade",
    "recover",
    "bubble",
    "acid-armor",
    "destiny-bond",
    "rain-dance",
    "shadow-ball",
    "whirlpool",
    "water-spout",
    "water-sport",
    "water-pulse",
    "brine",
    "wring-out",
    "ominous-wind",
    "hex"
  ],
  "moves": [
    "hydro-pump",
    "bubble-beam",
    "night-shade",
    "bubble",
    "rain-dance",
    "shadow-ball",
    "whirlpool",
    "water-spout",
    "brine",
    "confuse-ray",
    "aqua-cutter",
    "shadow-sneak",
    "aqua-tail"
  ],
  "evolution_chain": {
    "id": 301,
    "item": null,
    "species": [
      {
        "name": "frillish",
        "order": 593,
        "types": [
          PokeType.WATER,
          PokeType.GHOST
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "jellicent",
        "order": 594,
        "types": [
          PokeType.WATER,
          PokeType.GHOST
        ],
        "evolves_from_species_id": 592,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 40,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 157,
    "speed": 101,
    "ability_power": 142
  },
  "stat_changes": [],
  "catch_rate": 60,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
